import { z } from 'zod'
import { zfd } from 'zod-form-data'

const createSurveyBlockSchema = (fields: string[]) => {
	const fieldSchema = fields.reduce(
		(acc, field) => ({
			...acc,
			[field]: z
				.string()
				.optional()
				.refine(
					value =>
						value !== undefined && parseInt(value) >= 1 && parseInt(value) <= 5,
					'Value must be between 1 and 5',
				),
		}),
		{},
	)
	return z.object(fieldSchema, {
		required_error: 'Fill in the form to continue',
	})
}

export const BoatZod = z.object({
	boat: z.object(
		{
			id: zfd.numeric(),
			name: z.string(),
			height: z.string(),
			length: z.string(),
			crew: z.string(),
		},
		{
			required_error: 'Select a ship',
		},
	),
})
export const ageZod = z.object({ age: zfd.numeric() })
export const originZod = z.object({ origin: z.any() })
export const limitingFactorsZod = z.object({
	limitingFactors: z.string().min(10),
})

export const intakePathZod = z.object({ intakePath: z.string().min(2) })
export const countryZod = z.object({ country: z.string().min(2) })
export const otherLifeZod = z.object({ otherLife: z.string().min(2) })
export const socialLifeZod = z.object({ socialLife: z.string().min(2) })
export const emptyZod = z.any()
export const financialSituationLifeZod = z.object({
	financialSituationLife: z.string().min(2),
})
export const healthLifeZod = z.object({ healthLife: z.string().min(2) })
export const relationshipLifeZod = z.object({
	relationshipLife: z.string().min(2),
})

export const familyLifeZod = z.object({ familyLife: z.string().min(2) })
export const workLifeZod = z.object({ workLife: z.string().min(2) })
export const questionsZod = z.object({ questions: z.array(z.string()) })

export const survey1BlockZod = z.object({
	survey1Block: createSurveyBlockSchema(['i1', 'i2', 'i3', 'i4', 'i5', 'i6']),
})

export const i1Zod = z.object({ i1: z.string().min(1) })
export const i2Zod = z.object({ i2: z.string().min(1) })
export const i3Zod = z.object({ i3: z.string().min(1) })
export const i4Zod = z.object({ i4: z.string().min(1) })
export const i5Zod = z.object({ i5: z.string().min(1) })
export const i6Zod = z.object({ i6: z.string().min(1) })
export const i7Zod = z.object({ i7: z.string().min(1) })
export const i8Zod = z.object({ i8: z.string().min(1) })
export const i9Zod = z.object({ i9: z.string().min(1) })
export const i10Zod = z.object({ i10: z.string().min(1) })
export const i11Zod = z.object({ i11: z.string().min(1) })
export const i12Zod = z.object({ i12: z.string().min(1) })
export const i13Zod = z.object({ i13: z.string().min(1) })
export const i14Zod = z.object({ i14: z.string().min(1) })
export const i15Zod = z.object({ i15: z.string().min(1) })
export const i16Zod = z.object({ i16: z.string().min(1) })
export const i17Zod = z.object({ i17: z.string().min(1) })
export const i18Zod = z.object({ i18: z.string().min(1) })
export const i19Zod = z.object({ i19: z.string().min(1) })
export const i20Zod = z.object({ i20: z.string().min(1) })
export const i21Zod = z.object({ i21: z.string().min(1) })
export const i22Zod = z.object({ i22: z.string().min(1) })
export const i23Zod = z.object({ i23: z.string().min(1) })
export const i24Zod = z.object({ i24: z.string().min(1) })
export const i25Zod = z.object({ i25: z.string().min(1) })
export const i26Zod = z.object({ i26: z.string().min(1) })
export const i27Zod = z.object({ i27: z.string().min(1) })
export const i28Zod = z.object({ i28: z.string().min(1) })
export const i29Zod = z.object({ i29: z.string().min(1) })
export const i30Zod = z.object({ i30: z.string().min(1) })
export const i31Zod = z.object({ i31: z.string().min(1) })
export const i32Zod = z.object({ i32: z.string().min(1) })
export const i33Zod = z.object({ i33: z.string().min(1) })
export const i34Zod = z.object({ i34: z.string().min(1) })
export const i35Zod = z.object({ i35: z.string().min(1) })
export const i36Zod = z.object({ i36: z.string().min(1) })
export const i37Zod = z.object({ i37: z.string().min(1) })
export const i38Zod = z.object({ i38: z.string().min(1) })
export const i39Zod = z.object({ i39: z.string().min(1) })
export const i40Zod = z.object({ i40: z.string().min(1) })
export const i41Zod = z.object({ i41: z.string().min(1) })
export const i42Zod = z.object({ i42: z.string().min(1) })
export const i43Zod = z.object({ i43: z.string().min(1) })
export const i44Zod = z.object({ i44: z.string().min(1) })
export const i45Zod = z.object({ i45: z.string().min(1) })
export const i46Zod = z.object({ i46: z.string().min(1) })
export const i47Zod = z.object({ i47: z.string().min(1) })
export const i48Zod = z.object({ i48: z.string().min(1) })
export const i49Zod = z.object({ i49: z.string().min(1) })
export const i50Zod = z.object({ i50: z.string().min(1) })
export const i51Zod = z.object({ i51: z.string().min(1) })
export const i52Zod = z.object({ i52: z.string().min(1) })
export const i53Zod = z.object({ i53: z.string().min(1) })
export const i54Zod = z.object({ i54: z.string().min(1) })
export const i55Zod = z.object({ i55: z.string().min(1) })
export const i56Zod = z.object({ i56: z.string().min(1) })
export const i57Zod = z.object({ i57: z.string().min(1) })
export const i58Zod = z.object({ i58: z.string().min(1) })
export const i59Zod = z.object({ i59: z.string().min(1) })
export const i60Zod = z.object({ i60: z.string().min(1) })
export const i61Zod = z.object({ i61: z.string().min(1) })
export const i62Zod = z.object({ i62: z.string().min(1) })
export const i63Zod = z.object({ i63: z.string().min(1) })
export const i64Zod = z.object({ i64: z.string().min(1) })
export const i65Zod = z.object({ i65: z.string().min(1) })
export const i66Zod = z.object({ i66: z.string().min(1) })
export const i67Zod = z.object({ i67: z.string().min(1) })
export const i68Zod = z.object({ i68: z.string().min(1) })
export const i69Zod = z.object({ i69: z.string().min(1) })
export const i70Zod = z.object({ i70: z.string().min(1) })
export const i71Zod = z.object({ i71: z.string().min(1) })
export const i72Zod = z.object({ i72: z.string().min(1) })
export const i73Zod = z.object({ i73: z.string().min(1) })
export const i74Zod = z.object({ i74: z.string().min(1) })
export const i75Zod = z.object({ i75: z.string().min(1) })
export const i76Zod = z.object({ i76: z.string().min(1) })
export const i77Zod = z.object({ i77: z.string().min(1) })
export const i78Zod = z.object({ i78: z.string().min(1) })
export const i79Zod = z.object({ i79: z.string().min(1) })
export const i80Zod = z.object({ i80: z.string().min(1) })
export const i81Zod = z.object({ i81: z.string().min(1) })
export const i82Zod = z.object({ i82: z.string().min(1) })
export const i83Zod = z.object({ i83: z.string().min(1) })
export const i84Zod = z.object({ i84: z.string().min(1) })
export const i85Zod = z.object({ i85: z.string().min(1) })
export const i86Zod = z.object({ i86: z.string().min(1) })
export const i87Zod = z.object({ i87: z.string().min(1) })
export const i88Zod = z.object({ i88: z.string().min(1) })
export const i89Zod = z.object({ i89: z.string().min(1) })
export const i90Zod = z.object({ i90: z.string().min(1) })
export const i91Zod = z.object({ i91: z.string().min(1) })
export const i92Zod = z.object({ i92: z.string().min(1) })
export const i93Zod = z.object({ i93: z.string().min(1) })
export const i94Zod = z.object({ i94: z.string().min(1) })
export const i95Zod = z.object({ i95: z.string().min(1) })
export const i96Zod = z.object({ i96: z.string().min(1) })
export const i97Zod = z.object({ i97: z.string().min(1) })
export const i98Zod = z.object({ i98: z.string().min(1) })
export const i99Zod = z.object({ i99: z.string().min(1) })
export const i100Zod = z.object({ i100: z.string().min(1) })
export const i101Zod = z.object({ i101: z.string().min(1) })
export const i102Zod = z.object({ i102: z.string().min(1) })
export const i103Zod = z.object({ i103: z.string().min(1) })
export const i104Zod = z.object({ i104: z.string().min(1) })
export const i105Zod = z.object({ i105: z.string().min(1) })
export const i106Zod = z.object({ i106: z.string().min(1) })
export const i107Zod = z.object({ i107: z.string().min(1) })
export const i108Zod = z.object({ i108: z.string().min(1) })
export const i109Zod = z.object({ i109: z.string().min(1) })
export const i110Zod = z.object({ i110: z.string().min(1) })
export const i111Zod = z.object({ i111: z.string().min(1) })
export const i112Zod = z.object({ i112: z.string().min(1) })
export const i113Zod = z.object({ i113: z.string().min(1) })
export const i114Zod = z.object({ i114: z.string().min(1) })
export const i115Zod = z.object({ i115: z.string().min(1) })
export const i116Zod = z.object({ i116: z.string().min(1) })
export const i117Zod = z.object({ i117: z.string().min(1) })
export const i118Zod = z.object({ i118: z.string().min(1) })
export const i119Zod = z.object({ i119: z.string().min(1) })
export const i120Zod = z.object({ i120: z.string().min(1) })

export const personalityQuestionsZod = z.object({
	personalityQuestions: z.object({
		A: z.string(),
		'A2-A': z.string(),
		'A2-A2-A': z.string(),
		'A2-A2-B': z.string(),
		B: z.string(),
		B1: z.string(),
		B2: z.string(),
	}),
})

export const combinedIpipZod = survey1BlockZod
	.merge(ageZod)
	.merge(intakePathZod)
	.merge(countryZod)
	.merge(originZod)
	.merge(survey1BlockZod)
	.merge(personalityQuestionsZod)
	.merge(limitingFactorsZod)

const questionSchema = z.object({
	id: z.string(),
	text: z.string(),
	answer: z.string(),
})

export const submittedDataSchema = z.object({
	parentForm: z.string(),
	childForm: z.string().optional(),
	originZod: originZod.optional(),
	answeredQuestionsStack: z.array(z.string()),
	personalityQuestions: z.array(questionSchema),
	formState: z.any(),
})

export type CombinedIpipType = z.infer<typeof combinedIpipZod>

export type AgeType = z.infer<typeof ageZod>
export type IntakePathType = z.infer<typeof intakePathZod>
export type OriginType = z.infer<typeof originZod>
export type CountryType = z.infer<typeof countryZod>
export type QuestionsType = z.infer<typeof questionsZod>
export type LimitingFactorsType = z.infer<typeof limitingFactorsZod>
export type Survey1BlockType = z.infer<typeof survey1BlockZod>
export type PersonalityQuestionsType = z.infer<typeof personalityQuestionsZod>
export type SubmittedDataType = z.infer<typeof submittedDataSchema>
export type I1Type = z.infer<typeof i1Zod>
export type I2Type = z.infer<typeof i2Zod>
export type I3Type = z.infer<typeof i3Zod>
export type I4Type = z.infer<typeof i4Zod>
export type I5Type = z.infer<typeof i5Zod>
export type I6Type = z.infer<typeof i6Zod>
export type I7Type = z.infer<typeof i7Zod>
export type I8Type = z.infer<typeof i8Zod>
export type I9Type = z.infer<typeof i9Zod>
export type I10Type = z.infer<typeof i10Zod>
export type I11Type = z.infer<typeof i11Zod>
export type I12Type = z.infer<typeof i12Zod>
export type I13Type = z.infer<typeof i13Zod>
export type I14Type = z.infer<typeof i14Zod>
export type I15Type = z.infer<typeof i15Zod>
export type I16Type = z.infer<typeof i16Zod>
export type I17Type = z.infer<typeof i17Zod>
export type I18Type = z.infer<typeof i18Zod>
export type I19Type = z.infer<typeof i19Zod>
export type I20Type = z.infer<typeof i20Zod>
export type I21Type = z.infer<typeof i21Zod>
export type I22Type = z.infer<typeof i22Zod>
export type I23Type = z.infer<typeof i23Zod>
export type I24Type = z.infer<typeof i24Zod>
export type I25Type = z.infer<typeof i25Zod>
export type I26Type = z.infer<typeof i26Zod>
export type I27Type = z.infer<typeof i27Zod>
export type I28Type = z.infer<typeof i28Zod>
export type I29Type = z.infer<typeof i29Zod>
export type I30Type = z.infer<typeof i30Zod>
export type I31Type = z.infer<typeof i31Zod>
export type I32Type = z.infer<typeof i32Zod>
export type I33Type = z.infer<typeof i33Zod>
export type I34Type = z.infer<typeof i34Zod>
export type I35Type = z.infer<typeof i35Zod>
export type I36Type = z.infer<typeof i36Zod>
export type I37Type = z.infer<typeof i37Zod>
export type I38Type = z.infer<typeof i38Zod>
export type I39Type = z.infer<typeof i39Zod>
export type I40Type = z.infer<typeof i40Zod>
export type I41Type = z.infer<typeof i41Zod>
export type I42Type = z.infer<typeof i42Zod>
export type I43Type = z.infer<typeof i43Zod>
export type I44Type = z.infer<typeof i44Zod>
export type I45Type = z.infer<typeof i45Zod>
export type I46Type = z.infer<typeof i46Zod>
export type I47Type = z.infer<typeof i47Zod>
export type I48Type = z.infer<typeof i48Zod>
export type I49Type = z.infer<typeof i49Zod>
export type I50Type = z.infer<typeof i50Zod>
export type I51Type = z.infer<typeof i51Zod>
export type I52Type = z.infer<typeof i52Zod>
export type I53Type = z.infer<typeof i53Zod>
export type I54Type = z.infer<typeof i54Zod>
export type I55Type = z.infer<typeof i55Zod>
export type I56Type = z.infer<typeof i56Zod>
export type I57Type = z.infer<typeof i57Zod>
export type I58Type = z.infer<typeof i58Zod>
export type I59Type = z.infer<typeof i59Zod>
export type I60Type = z.infer<typeof i60Zod>
export type I61Type = z.infer<typeof i61Zod>
export type I62Type = z.infer<typeof i62Zod>
export type I63Type = z.infer<typeof i63Zod>
export type I64Type = z.infer<typeof i64Zod>
export type I65Type = z.infer<typeof i65Zod>
export type I66Type = z.infer<typeof i66Zod>
export type I67Type = z.infer<typeof i67Zod>
export type I68Type = z.infer<typeof i68Zod>
export type I69Type = z.infer<typeof i69Zod>
export type I70Type = z.infer<typeof i70Zod>
export type I71Type = z.infer<typeof i71Zod>
export type I72Type = z.infer<typeof i72Zod>
export type I73Type = z.infer<typeof i73Zod>
export type I74Type = z.infer<typeof i74Zod>
export type I75Type = z.infer<typeof i75Zod>
export type I76Type = z.infer<typeof i76Zod>
export type I77Type = z.infer<typeof i77Zod>
export type I78Type = z.infer<typeof i78Zod>
export type I79Type = z.infer<typeof i79Zod>
export type I80Type = z.infer<typeof i80Zod>
export type I81Type = z.infer<typeof i81Zod>
export type I82Type = z.infer<typeof i82Zod>
export type I83Type = z.infer<typeof i83Zod>
export type I84Type = z.infer<typeof i84Zod>
export type I85Type = z.infer<typeof i85Zod>
export type I86Type = z.infer<typeof i86Zod>
export type I87Type = z.infer<typeof i87Zod>
export type I88Type = z.infer<typeof i88Zod>
export type I89Type = z.infer<typeof i89Zod>
export type I90Type = z.infer<typeof i90Zod>
export type I91Type = z.infer<typeof i91Zod>
export type I92Type = z.infer<typeof i92Zod>
export type I93Type = z.infer<typeof i93Zod>
export type I94Type = z.infer<typeof i94Zod>
export type I95Type = z.infer<typeof i95Zod>
export type I96Type = z.infer<typeof i96Zod>
export type I97Type = z.infer<typeof i97Zod>
export type I98Type = z.infer<typeof i98Zod>
export type I99Type = z.infer<typeof i99Zod>
export type I100Type = z.infer<typeof i100Zod>
export type I101Type = z.infer<typeof i101Zod>
export type I102Type = z.infer<typeof i102Zod>
export type I103Type = z.infer<typeof i103Zod>
export type I104Type = z.infer<typeof i104Zod>
export type I105Type = z.infer<typeof i105Zod>
export type I106Type = z.infer<typeof i106Zod>
export type I107Type = z.infer<typeof i107Zod>
export type I108Type = z.infer<typeof i108Zod>
export type I109Type = z.infer<typeof i109Zod>
export type I110Type = z.infer<typeof i110Zod>
export type I111Type = z.infer<typeof i111Zod>
export type I112Type = z.infer<typeof i112Zod>
export type I113Type = z.infer<typeof i113Zod>
export type I114Type = z.infer<typeof i114Zod>
export type I115Type = z.infer<typeof i115Zod>
export type I116Type = z.infer<typeof i116Zod>
export type I117Type = z.infer<typeof i117Zod>
export type I118Type = z.infer<typeof i118Zod>
export type I119Type = z.infer<typeof i119Zod>
export type I120Type = z.infer<typeof i120Zod>
